/**
 * Display metadata for PLATFORM feed keys only (platform_admin, `/admin/platform-credentials*`,
 * policylens-backend/src/services/platformServiceCredentialProviders.ts). The card list itself is
 * driven by what the server returns; this map only adds friendlier labels.
 *
 * Lead Advisor integration providers (e-sign, enrichment) are NEVER listed here: they come from
 * `GET /me/integrations/providers`, which only lists providers that have a real adapter.
 */
export const PLATFORM_FEED_PROVIDERS = Object.freeze([
    {
        id: 'ALIENVAULT_OTX',
        label: 'AlienVault OTX API key',
        description: 'Used by the threat-intelligence feed fetcher (OTX pulses). Platform-wide; not visible to tenants.',
    },
]);
